/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */

export const msalConfig = {
    // auth: {
    //     clientId: "44b60757-5fe8-4226-9651-4b193cbb3f73",
    //     authority: "https://login.microsoftonline.com/fa4af9bd-781e-4f55-a185-a1be0e1e326b",

    //     //clientId: "23252b05-e13d-46b2-a771-2a5e7e336fab",
    //     //authority: "https://login.microsoftonline.com/cb836993-a028-4aae-bd38-46160b485792",
    //     //redirectUri: "http://localhost:3000",
    //     //redirectUri: "https://dev.d2u2rdi7k56n6u.amplifyapp.com",
    //     redirectUri: "https://dev.d1nwl1fh8ku0ui.amplifyapp.com"
    // },


    auth: {
        clientId: `${process.env.REACT_APP_CLIENT_ID}`,
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID}`,
        redirectUri: `${process.env.REACT_APP_DEPLOY_URL}`
        
        // redirectUri:
        //   process.env.NODE_ENV === 'development'
        //     ? 'http://localhost:3000/'
        //     : process.env.REACT_APP_DEPLOY_URL,
      },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {	
        loggerOptions: {	
            loggerCallback: (level, message, containsPii) => {	
                if (containsPii) {		
                    return;		
                }		
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }	
            }	
        }	
    }
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ["User.Read"]
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};